import { Component, Prop, Vue } from "vue-property-decorator";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { appConfigService } from "@/providers/services/app/app-config";
import axios from "axios";
@Component({
  components: {
    AppLoaderComponent,
  },
})
export default class PreviewPopupComponent extends Vue {
  @Prop()
  public fileDetails!: any[];
  @Prop()
  public keyName!: string;
  @Prop()
  public typeOfView!: string;
  @Prop()
  public isPeerPreview!: any;
  public S3Path = "";
  public imgType = ["jpg", "png", "jpeg", "tiff"];
  public docType = ["pdf", "doc"];
  public isLoading = false;
  public slideIndex = 0;
  public totalLength = 0;

  public getFileExtension(file: any) {
    const rawFileName =
      file?.uploadedFileName ||
      file?.fileName ||
      file?.originalFileName ||
      file?.name;
    if (rawFileName && rawFileName.includes(".")) {
      return rawFileName.split(".").pop().toLowerCase();
    }
    if (file?.type) {
      return file.type.includes("/")
        ? file.type.split("/").pop().toLowerCase()
        : file.type.toLowerCase();
    }
    return "";
  }

  public mounted() {
    let getFileType = "";
    this.$nextTick().then(() => {
      this.totalLength = this.fileDetails.length;
      this.S3Path =
        this.typeOfView === "certificate" || this.isPeerPreview
          ? appConfigService.getS3CertificatesFilesPathUrl()
          : appConfigService.getS3FilesPathUrl();
      this.fileDetails.length &&
        this.fileDetails.map((file: any) => {
          getFileType = this.getFileExtension(file);
          file.type = getFileType;
          if (this.docType.includes(getFileType)) {
            file.isDocument = true;
            file.isImage = false;
          } else {
            file.isDocument = false;
            file.isImage = true;
          }
        });
      this.isLoading = true;
      this.$bvModal.show(`preview-modal-center-` + this.keyName);
    });
  }

  public hide(event: any) {
    if (event) {
      this.$emit("hidePreviewPopup", true);
    }
  }
  public async downloadImageFromServer(data: any, getImageName: any) {
    try {
      const response = await axios({
        url: data,
        method: "GET",
        responseType: "blob",
      });
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = getImageName;
      link.click();
    } catch (error) {
      console.error(error);
    }
  }

  public loadData(event: any) {
    this.isLoading = false;
  }

  public prev() {
    if (this.slideIndex <= this.totalLength - 1 && this.slideIndex != 0) {
      this.isLoading = true;
      this.slideIndex--;
    }
  }
  public next() {
    if (this.slideIndex < this.totalLength - 1) {
      this.isLoading = true;
      this.slideIndex++;
    }
  }

  public closePopup() {
    this.$bvModal.hide(`preview-modal-center-` + this.keyName);
    this.slideIndex = 0;
  }
}
